import { Component, Input, OnInit } from '@angular/core';
import { ViewChild, ElementRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { FormComponent } from '../../../../../models/FormComponent';
import { Product } from '../../../../../models/Product';
import { ProductValidatorService, ValidationErrorSettings, ValidationAlertSettings } from "../../../../../services/validators/product-validator.service";

@Component({
  selector: 'app-ape-sku',
  templateUrl: './ape-sku.component.html',
  styleUrls: ['./ape-sku.component.scss']
})
export class ApeSkuComponent extends FormComponent implements OnInit {
  @Input('product') product: Product; //assigned a COPY so that original is maintained to check diff.
  @ViewChild('formElement') formElement:ElementRef;
  @ViewChild('formData') formData:NgForm;
  get fieldId():string { return '#'+this.formData.name }
  get fieldValue():string { return this.formData.value as string }

  constructor( 
    private _productValidator:ProductValidatorService 
  )
  { super() }


  ngOnInit() { 
    let validationErrorSettings:ValidationErrorSettings = {fieldNameForMessage:'Sku', required:true, minlength:4};
    let validateAlertFunction = this._productValidator.validateForSkuAlert;
    let validationAlertSettings:ValidationAlertSettings = {fieldNameForMessage:'Sku', required:true, validateAlertFunction:validateAlertFunction};
    this.initParent(this.product, this.formElement, this.formData, this._productValidator, validationErrorSettings, validationAlertSettings);
  }


}






//==================
// Unused Code

        // console.log('$e.target', $e.target);
    // let sku = $e.target.value as string;
    //no alert for invalid sku
    // if(!sku || sku.length < 4){
      //hide both
      // $('#flashSkuAvailable').hide();
      // $('#flashSkuTaken').hide();
      // console.log('hide both b/c sku value is', sku);
      // return;
    // }
    // if(skuExists){
    //   //warn user that sku already taken
    //   // console.log('sku taken');
    //   $('#flashSkuAvailable').hide();
    //   $('#flashSkuTaken').show();
    // } else {
    //   //say its available      
    //   // console.log('sku available');
    //   $('#flashSkuTaken').hide();
    //   $('#flashSkuAvailable').show();
    // }

  // onFormChange1($e){
  //   // console.log('$event', $e);
  //   let sku = $e as string;

  //   //VALIDATE SKU
  //   let result = this.validator.skuValidator(sku);
  //   // console.log('validation result', result);

  //   // sku availability (or hide if invalid sku)
  //   if(result.success == false){
  //     $("#apeSkuAlert").hide();
  //   } else {
  //     //skuinput is valid.  proceed with skucheck
  //     $("#apeSkuAlert").show();
  //     this.checkSkuAvailability(sku);
  //   }
    
  //   // form errors, only show after initial blur
  //   if(this.form.touched && result.success == false){
  //     $('#apeSkuError').html(result.message);
  //     $('#apeSkuError').show();
  //   } else {
  //     $('#apeSkuError').hide();
  //   }
  // }


  // //see if proposedSku exists in loadedProducts.  Not using REST for this presently.
  // //caller: html input for checkSku
  // //TODO: move this to productValidator
  // checkSkuAvailability(skuValue, alertElementId){
  //   //show alert for sku: 'available' or 'taken
  //   let skuExists = this.productService.checkSkuExists(skuValue);
    
  //   if(skuExists){
  //     $(alertElementId).removeClass( "alert-success" ).addClass( "alert-danger" );
  //     $(alertElementId).html('Sku already taken');
  //   }
  //   else {
  //     $(alertElementId).removeClass( "alert-danger" ).addClass( "alert-success" );
  //     $(alertElementId).html('Available');
  //   }

  // }


// WEBPACK FOOTER //
// ./src/app/components/admin/admin-products/admin-product-edit/ape-sku/ape-sku.component.ts